import { useEffect } from "react";
import { Button, Dialog, H2 } from "@blueprintjs/core";
import { selectCurrentDialogue, setCurrentDialogue } from "controllers/common/action";
import { useDispatch, useSelector } from "react-redux";
import { Analytics } from "utils/analytics";
import "./VerifyEmail.scss";

interface VerifyEmailProps {
  email: string;
}
export default function VerifyEmail(props: VerifyEmailProps) {
  const { email } = props;
  const dispatch = useDispatch();
  const currentDialogue = useSelector(selectCurrentDialogue);
  const shouldOpen = currentDialogue === "VerifyEmail";

  const handleSignUp = () => dispatch(setCurrentDialogue("SignUp"));
  const shouldClose = () => dispatch(setCurrentDialogue(""));

  const handleSubmit = () => {
    //Todo: current resend email api hasn't been completed
    dispatch(setCurrentDialogue(""));
  };

  useEffect(() => {
    if (shouldOpen) {
      Analytics.getInstance().event("Verify Email", "Opened");
    }
    return () => {};
  }, [shouldOpen]);

  return (
    <Dialog className="verify-email" isOpen={shouldOpen}>
      <div className="form__header">
        <H2>Verify Your Email</H2>
        <Button minimal intent="primary" icon="cross" onClick={shouldClose} />
      </div>
      <form onSubmit={handleSubmit}>
        <p>
          An email verification has been sent to <strong>{email}</strong>.
        </p>

        <div className="form__footer">
          <div></div>
          <div>
            <Button
              className="button-right"
              minimal
              intent="primary"
              key="signup"
              text="Back To Create Account"
              onClick={handleSignUp}
            />
            <Button
              className="button-submit"
              type="submit"
              intent="primary"
              key="resend"
              text="Close"
              onClick={shouldClose}
            />
          </div>
        </div>
      </form>
    </Dialog>
  );
}
